export default class LazyLoader {
    constructor(el, lazylevel, cball, cb) {
        this.el = el;
        this.cb = cb instanceof Function ? cb : () => {};
        this.cball = cball instanceof Function ? cball : () => {};
        this.lazyblocks = this.el.querySelectorAll(Number.isNaN(parseInt(lazylevel, 10)) ? '.lazy-load-block' : `.lazy-level-${lazylevel}`);
        this.images = this.getImages();
        this.finished = Promise.all(this.images.map((i) => i.isLoaded));
        this.bind();
    }

    getImages() {
        const images = [];
        this.lazyblocks.forEach((block) => {
            if (block.nodeName === 'PICTURE') {
                images.push(block.querySelector('img'));
            }

            if (block.nodeName === 'IMG') {
                images.push(block);
            }
        });

        return images.map((el) => ({ el, isLoaded: this.attachImageEvents(el) }));
    }

    attachImageEvents(el) {
        const img = el;
        return new Promise((resolve) => {
            img.addEventListener('load', () => {
                resolve();
                this.cb(img);
            });
            img.addEventListener('error', () => {
                resolve();
                this.cb(img);
            });
        });
    }

    bind() {
        this.finished.then(() => this.cball(this.images.map((i) => i.el)));
    }

    load() {
        this.lazyblocks.forEach((block) => {
            if (block.nodeName === 'PICTURE') {
                const srcToReplace = block.querySelectorAll('[data-srcset], [data-src]');
                srcToReplace.forEach((ele) => {
                    const currentEle = ele;
                    const { src, srcset } = ele.dataset;
                    if (src !== undefined && src.length) {
                        currentEle.src = src;
                    }
                    if (srcset !== undefined && srcset.length) {
                        currentEle.srcset = srcset;
                    }
                });
            }

            if (block.nodeName === 'IMG') {
                const currentBlock = block;
                currentBlock.src = block.dataset.src;
            }
        });
    }
}
